import { SimpleSearchFilter } from 'api/dashboard/widget';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';

export enum ResourceManagmentViewType {
  Users = 'PEOPLE',
  Projects = 'PROJECT',
}
export enum ApiZoomLevel {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
}
export interface ApiResourceManagementViewDefinition {
  filter?: SimpleSearchFilter;
  allocations: {
    view: ResourceManagmentViewType;
  };
}
export interface ResourceManagementViewDefinition {
  filter: GroupedFilter;
}
